// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineSelectPropsSchema = z.object({
	style: mantineCssStyleRecordSchema.optional(),
	label: z.string().optional(),
	placeholder: z.string().optional(),
});
